<template>
  <div class="channel-bind-dia">
    <el-dialog
      title="外部机型绑定"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      width="950px"
      top="3%"
      @close="close"
    >
      <div style="padding-bottom: 50px;">
        <p style="margin-bottom: 20px;">平台机型： {{ currentRow.name }}</p>
        <div class="el-table-container">
          <el-table
            v-loading="tableLoading"
            :data="tableDataList"
            :span-method="objectSpanMethod"
            border
            max-height="500"
          >
            <el-table-column prop="channelName" label="机型来源" align="center">
            </el-table-column>
            <el-table-column
              label="绑定机型"
              prop="outMachineName"
              align="center"
            >
              <template slot-scope="{ row }">
                <span v-if="row.outMachineName">{{ row.outMachineName }}</span>
                <span style="color: #ff687b;" v-else>暂未绑定</span>
              </template>
            </el-table-column>
            <el-table-column
              label="绑定操作人"
              prop="bindUsername"
              align="center"
            >
              <template slot-scope="{ row }">
                <span>{{ row.bindUsername || "--" }}</span>
                <span v-if="row.bindAccount">-{{ row.bindAccount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bindTime" label="绑定时间" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.bindTime || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="{ row }">
                <el-button
                  type="text"
                  style="color: #ff687b;text-decoration: underline;"
                  v-if="row.outMachineName"
                  @click="cancelBind(row)"
                  >取消绑定</el-button
                >
                <el-button
                  type="text"
                  style="text-decoration: underline;"
                  v-else
                  @click="$refs['addModelBindDia'].open(row)"
                  >添加绑定</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <AddModelBindDia
      ref="addModelBindDia"
      :currentRow="currentRow"
      @confirm="getTableData"
    />
  </div>
</template>

<script>
import _api from "@/utils/request";
import AddModelBindDia from "./AddModelBindDia.vue";
import { confirm } from "@/components/common/messagebox";
export default {
  components: { AddModelBindDia },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    currentRow: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableLoading: false,
      tableDataList: [],
      tableColumns: [
        { label: "机型来源", prop: "channelName" },
        { slotName: "outMachineName" },
        { slotName: "bindStaff" },
        { label: "绑定时间", prop: "bindTime" },
        { slotName: "operation" },
      ],
      spanArr: [], // 存储合并信息
    };
  },
  created() {
    this.getTableData();
  },
  mounted() {
    // 初始化时计算合并信息
    this.processedData;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getTableData() {
      this.tableLoading = true;
      _api
        .getModelChannelList({ id: this.currentRow.id })
        .then((res) => {
          if (res.data && res.data.length) {
            this.tableDataList = res.data.flatMap((item) => item.outModelViews);
            this.spanArr = [];
            let pos = 0;
            // 先按channel分组
            for (let i = 0; i < this.tableDataList.length; i++) {
              if (i === 0) {
                this.spanArr.push(1);
                pos = 0;
              } else {
                // 如果当前channel与上一个相同，则合并
                if (
                  this.tableDataList[i].channel ===
                  this.tableDataList[i - 1].channel
                ) {
                  this.spanArr[pos] += 1;
                  this.spanArr.push(0);
                } else {
                  this.spanArr.push(1);
                  pos = i;
                }
              }
            }
            console.log(this.spanArr, "datadatadatadatadatadatadata");
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    cancelBind(row) {
      const { channel, channelName, outMachineName } = row;
      console.log(channel, "channelchannel");
      let desc = `说明：取消绑定后，无法通过选择该机型查询原${channelName}关联机型的预估价`;
      if (
        channel === "chxs" ||
        channel === "hi" ||
        channel === "cmcc" ||
        channel === "dh" ||
        channel === "lb" ||
        channel === "lbts" ||
        channel === "cl-jxy"
      ) {
        desc = `说明：取消绑定后，该渠道使用该机型下单将默认为其他机型`;
      }
      confirm({
        title: "取消绑定提示",
        width: "550px",
        desc,
        message: `是否确认取消<span style="color: red">${this.currentRow.name}</span>与${channelName}机型<span style="color: red">${outMachineName}</span>的绑定关系？`,
        confirm: () => {
          _api
            .cancelBind({
              channel: channel,
              machineId: row.machineId,
              outMachineId: row.outMachineId,
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "取消成功!",
              });
              this.getTableData();
            });
        },
      });
    },
    // 合并单元格的方法
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 只对第一列（渠道信息）进行合并
      if (columnIndex === 0) {
        const rowspan = this.spanArr[rowIndex];
        const colspan = rowspan > 0 ? 1 : 0;
        if (rowspan > 0) {
          // 这里通过自定义属性返回类名，实际应用中可能需要其他方式设置样式
          return {
            rowspan: rowspan,
            colspan: colspan,
          };
        }
        return {
          rowspan: rowspan,
          colspan: colspan,
        };
      }
    },
  },
};
</script>

<style scoped lang="scss">
.channel-bind-dia {
}
</style>
